import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Button } from '@ascension/ui-library';
import ModalViewer from '@components/Modal/ModalViewer';
import { BLOCK_RELEASE_IN_USE_MODAL } from '@components/Modal/modalConstants';
import { useModalContext } from '@components/Modal/ModalContextProvider';
import { useHomeNavigationContext } from '@components/HeaderSection/NavigationOptions/HomeNavigationContext/HomeNavigationContext';
import { useBlockReleaseRequestContext } from '@components/BlockRelease/BlockReleaseRequest/BlockReleaseRequestContext/BlockReleaseRequestContext';

const useStyles = makeStyles((theme) =>
	createStyles({
		message: {
			color: 'rgba(0, 0, 0, 0.6)',
			fontWeight: 600,
			margin: theme.spacing(3, 0),
		},
		buttonContainer: {
			display: 'flex',
			justifyContent: 'space-between',
			height: '48px',
		},
		viewBlockDetails: {
			'backgroundColor': theme.palette.primary.main,
			'color': theme.palette.common.white,
			'&:hover': {
				backgroundColor: theme.palette.primary.dark,
			},
		},
		root: {
			width: '600px',
			padding: theme.spacing(2, 3, 3, 3),
		},
	}),
);

export const BlockReleaseInUseDialog = () => {
	const classes = useStyles();

	const { blockAccessor } = useBlockReleaseRequestContext();
	const { closeModal } = useModalContext();
	const { handleGoBack } = useHomeNavigationContext();

	const { id, message, title } = BLOCK_RELEASE_IN_USE_MODAL;
	const blockAccessorName = blockAccessor[0] && `${blockAccessor[0].firstName} ${blockAccessor[0].lastName}`;
	const blockInUseMessage = message && message.replace(':name:', blockAccessorName);

	return (
		<ModalViewer id={id} className={classes.root}>
			<Typography component="h2" variant="h6">
				{title} {blockAccessorName}
			</Typography>
			<Typography className={classes.message}>
				{blockInUseMessage}
			</Typography>
			<Box className={classes.buttonContainer}>
				<Button
					data-field="releaseRequestPage-releaseInUseModal-goHomeButton"
					color="primary"
					onClick={handleGoBack}
				>
					Go home
				</Button>
				<Button
					data-field="releaseRequestPage-releaseInUseModal-viewBlockDetailsButton"
					className={classes.viewBlockDetails}
					onClick={() => closeModal(id)}
				>
					View block details
				</Button>
			</Box>
		</ModalViewer>
	);
};
